export default __webpack_public_path__ + "static/media/Db2.41b0abd1.mp3";